import { combineReducers, configureStore } from "@reduxjs/toolkit";
import persistReducer from "redux-persist/es/persistReducer";
import persistStore from "redux-persist/es/persistStore";
// import storage from "redux-persist/lib/storage"; // <-- localStorage
import storageSession from "redux-persist/lib/storage/session";  // <-- sessionStorage
import FetchDataJson from "./Reducers/Shared/FetchDataJson/index";
import ApplicationInformation from "./Reducers/Shared/ApplicationInformation";
import UserInfoSlice from "./Reducers/Shared/UserInfo";
import VariousVariables from "./Reducers/Shared/VariousVariables";
import Login from "./Reducers/Shared/Login";
import globalLoadingSlice from "./Reducers/Shared/globalLoading/";
import arrayDataCheckBoks from "./Reducers/Shared/CheckBox/index";
import PublicTimePeriod from "./Reducers/Shared/PublicTimePeriod";
import ApplicantInformation from "./Reducers/Submitter/ApplicantInformation";
import CurrentJobInformationSpecialization from "./Reducers/Submitter/CurrentJobInformationSpecialization";
import WorkExperience from "./Reducers/Submitter/WorkExperience";
import AcademicAchievement from "./Reducers/Submitter/AcademicAchievement";
import VolunteerCommunityWork from "./Reducers/Submitter/VolunteerCommunityWork";
import AwardSource from "./Reducers/Submitter/AwardSource";
import AttachmentsAnswer from "./Reducers/Submitter/AttachmentsAnswer";
import Commitment from "./Reducers/Submitter/Commitment";
import DetailsOfResearchSubmittedForAwardLastFiveYears from "./Reducers/Submitter/DetailsOfResearchSubmittedForAwardLastFiveYears";
import QuestionsAnswers from "./Reducers/Submitter/QuestionsAnswers";
import ResearcherIndicators from "./Reducers/Submitter/ResearcherIndicators";
import SC_NT_AI_ApplicationInformation from "./Reducers/Submitter/SC_NT_AI_ApplicationInformation";
import SC_ST_AI_Field from "./Reducers/Submitter/SC_ST_AI_Field";
import SC_ST_AI_Subject from "./Reducers/Submitter/SC_ST_AI_Subject";
import SC_ST_RA_ParticipationType from "./Reducers/Submitter/SC_ST_RA_ParticipationType";
import languageReducer from "./Reducers/Shared/language/index";
import EncryptionReducer from "./Reducers/Shared/Encryption/index";
import WorkAndEducationInformationValidation from "./Reducers/Submitter/WorkAndEducationInformationValidation";
import ValidationScientificContributionSubmitted from "./Reducers/Submitter/ValidationScientificContributionSubmitted";
import AllRoundActive from "./Reducers/Manager/Dropdowns/GetAllRoundActive";
import AllFieldsManager from "./Reducers/Manager/Dropdowns/GetAllFieldsManager";
import AllSubjectManager from "./Reducers/Manager/Dropdowns/GetAllSubjectManager";
import AllFlow from "./Reducers/Manager/Dropdowns/GetAllFlow";
import AllCurrentFlow from "./Reducers/Manager/Dropdowns/GetCurrentFlow";
import TransferFromEvaluator from "./Reducers/Manager/Dropdowns/TransferFromEvaluator";
import TransferToEvaluator from "./Reducers/Manager/Dropdowns/TransferToEvaluator";
import MarksManager from "./Reducers/Manager/Marks";
import StepsWorkFlow from "./Reducers/Manager/WorkFlowSteps";
import EvaluatorInfo from "./Reducers/Manager/EvaluatorInfo";
import FlowActionEmployee from "./Reducers/Manager/FlowActionEmployee";
import FlowActionScientificCommittee from "./Reducers/Manager/FlowActionScientificCommittee";
import ScientificCommittee from "./Reducers/Manager/ScientificCommittee";
import SubTask from "./Reducers/Manager/SubTask";
import Tasks from "./Reducers/Manager/Tasks";
import FlowComponent from "./Reducers/Manager/FlowComponent";

import RouteManagerReducer from "./Reducers/Manager/RouteManager";

import QuestionSelectableTagsList from "./Reducers/Manager/Dropdowns/QuestionSelectableTagsList";
import FlowActionEvaluator from "./Reducers/Manager/FlowActionEvaluator";
import CompressAttachments from "./Reducers/Shared/CompressAttachments/index";
import Survey from "./Reducers/Shared/Survey"
const rootReducer = combineReducers({
  // your reducers here
  ApplicationInformation,
  FetchDataJson,
  UserInfo: UserInfoSlice,
  refreshTableStatus: VariousVariables,
  Login,
  globalLoading: globalLoadingSlice,
  arrayDataCheckBoks: arrayDataCheckBoks,
  PublicTimePeriod,
  ApplicantInformation,
  CurrentJobInformationSpecialization,
  WorkExperience,
  AcademicAchievement,
  VolunteerCommunityWork,
  AwardSource,
  AttachmentsAnswer,
  Commitment,
  DetailsOfResearchSubmittedForAwardLastFiveYears,
  QuestionsAnswers,
  ResearcherIndicators,
  SC_NT_AI_ApplicationInformation,
  SC_ST_AI_Field,
  SC_ST_AI_Subject,
  SC_ST_RA_ParticipationType,
  languageReducer,
  EncryptionReducer,
  WorkAndEducationInformationValidation,
  ValidationScientificContributionSubmitted,
  //////////////////////Manager////////////////////////////////////
  AllRoundActive,
  AllFieldsManager,
  AllSubjectManager,
  AllFlow,
  AllCurrentFlow,
  TransferFromEvaluator,
  TransferToEvaluator,
  MarksManager,
  StepsWorkFlow,
  EvaluatorInfo,
  FlowActionEmployee,
  FlowActionScientificCommittee,
  ScientificCommittee,
  SubTask,
  Tasks,
  FlowComponent,

  RouteManagerReducer,

  QuestionSelectableTagsList,
  FlowActionEvaluator,
  CompressAttachments,
  Survey,

  //////////////////////Manager////////////////////////////////////
});
const persistConfig = {
  key: "root",
  storage:storageSession,
  whitelist: ["UserInfo", "Login", "arrayDataCheckBoks"], // فقط حفظ هذين
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// ====== Store & Persistor ======
export const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
});
export const persistor = persistStore(store);
